/**
 * @file wq-recently-viewed.js
 * @description Track recently viewed products via localStorage,
 *   render on collection pages and homepage.
 *   Max 10 products stored. Renders cards dynamically.
 * @sprint Design System | Phase 3.4
 */
window.WQ = window.WQ || {};

window.WQ.RecentlyViewed = (() => {
  'use strict';

  var STORAGE_KEY = 'wq_recently_viewed';
  var MAX_ITEMS = 10;

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) { /* quota exceeded */ }
  }

  /**
   * Track the current product page.
   * Call this on PDP pages.
   */
  function trackProduct(product) {
    if (!product || !product.id) return;

    var items = getItems();

    // Remove if already exists (will re-add at front)
    items = items.filter(function(i) { return i.id !== product.id; });

    // Add to front
    items.unshift({
      id: product.id,
      title: product.title,
      url: product.url,
      price: product.price,
      image: product.image || '',
      sku: product.sku || '',
      vendor: product.vendor || ''
    });

    // Trim to max
    if (items.length > MAX_ITEMS) {
      items = items.slice(0, MAX_ITEMS);
    }

    saveItems(items);
  }

  /**
   * Render recently viewed products into a container.
   */
  function render(containerId, maxShow) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var items = getItems();
    var limit = maxShow || 5;

    if (items.length === 0) {
      container.style.display = 'none';
      return;
    }

    var shown = items.slice(0, limit);

    var html =
      '<h3 class="wq-recent__title">Recently Viewed</h3>' +
      '<div class="wq-recent__grid">';

    for (var i = 0; i < shown.length; i++) {
      var item = shown[i];
      html +=
        '<a href="' + item.url + '" class="wq-recent__card">' +
          '<div class="wq-recent__image">' +
            (item.image
              ? '<img src="' + item.image + '" alt="' + escapeAttr(item.title) + '" loading="lazy" width="80" height="80">'
              : '<div class="wq-recent__placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></div>') +
          '</div>' +
          '<div class="wq-recent__info">' +
            '<span class="wq-recent__name">' + escapeHtml(item.title) + '</span>' +
            (item.price ? '<span class="wq-recent__price">' + item.price + '</span>' : '') +
          '</div>' +
        '</a>';
    }

    html += '</div>';

    if (items.length > limit) {
      html += '<button class="wq-recent__clear" id="wq-recent-clear">Clear History</button>';
    }

    container.innerHTML = html;
    container.style.display = 'block';

    // Bind clear
    var clearBtn = document.getElementById('wq-recent-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        saveItems([]);
        container.style.display = 'none';
      });
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return str.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Auto-init: track current product if on PDP
  function init() {
    var productJson = document.querySelector('[data-wq-product-json]');
    if (productJson) {
      try {
        var data = JSON.parse(productJson.textContent);
        trackProduct(data);
      } catch (e) { /* ignore parse errors */ }
    }

    // Auto-render into any container with id="wq-recently-viewed"
    render('wq-recently-viewed', 5);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    trackProduct: trackProduct,
    render: render,
    getItems: getItems
  };
})();
